import styled,{css} from 'styled-components';
import media from 'src/styles/Media.styled';

export const TabMenuContainer = styled.div``;
export const MenuItem = styled.li`
    font-size: 15px;
    height: 1.75rem;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    color: #000000;
    cursor: pointer;
    /* &:hover,
    :active {
        cursor: pointer;
        border-bottom: 3px solid #1010eb;
    } */
    display: inline-flex;
    margin: ${(props) => (props.margin ? props.margin : '0 0 0 25px')};
    border-bottom: ${(props) => (props.selected ? '3px solid #1010eb' : '')};
`;

export const OptionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 10px 0 10px 0;
    ${media.mobileDevice`
        display:flex;
        flex-wrap:wrap;
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : 0)};
    `}
`;
export const CollapsableHeader = styled.span`
    color :#4F4F4F ;
    opacity: 1;
    letter-spacing: -0.12px;
`;
export const Header = styled.div`
    background: #f5f5f5 0% 0% no-repeat padding-box;
    width: 112%;
    height: 33px;
    text-align: left;
    padding-top: 7px;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;
    align-items: center;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 25px;
    ${media.mobileDevice`
        padding-bottom: 5px;
    `};
`;
export const DataTableContainer = styled.div`
    margin: 10px 0 0 0;
    ${media.mobileDevice`
    `}
`;
export const TextContainer = styled.div`
    color: #202124;
    opacity: 0.8;
    font-family: AvenirNextWorld Regular;
    padding: 10px;
    ${media.mobileDevice`
        padding: 15px 10px;
    `}
`;

export const ErrorText = styled.p`
    font-family: AvenirNextWorld Regular;
    color: #ed002a;
    letter-spacing: 0px;
    color: #ed002a;
    opacity: 1;
    font-size: 14px;
    line-height: 24px;
    display: inline-block;
    margin: 0;
    width: 50%;
    ${media.mobileDevice`
         width: 100%;
    `}
`;

export const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 35%;
    ${media.mediumDevice`
        width: 50%;
    `}
    ${media.smalDevice`
        width: 45%;
    `}
    ${media.mobileDevice`
        flex-direction: column-reverse;
        align-items: flex-start;
        width: 100%;
    `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        width: 50%;
    }


`;

export const Subtitle = styled.p`
    margin: ${({ margin }) => (margin ? margin : 0)};
    display: ${({ display }) => display && display};
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    width: ${({ width }) => (width ? width : '100%')};
    ${media.mobileDevice`
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '90%')};
    `}
    cursor: ${({ cursor }) => cursor};
    background-color: ${({ backgroundColor }) => backgroundColor};
    white-space: break-spaces;
`;

export const ShippedQty = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    height: 80%;
`;
export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    height: ${({ height }) => height};
    ${media.smalDevice`
        padding :${({ smPadding }) => (smPadding ? smPadding : '0.5rem')}; ;
    `}
    ${media.mobileDevice`
        width: 100%;
        height: ${({ mbHeight }) => mbHeight};
    `}
    ${media.largeDevice`
        width:${({ ldWidth }) => ldWidth && ldWidth};
    `}
`;

export const OrderDetailFooterContainer = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    align-items: center;
    justify-content: flex-start;
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before,
            &:after {
                content: ' | ';
            }
        `}

    ${({ isCreatedDateBy }) =>
        isCreatedDateBy &&
        css`
            &:after {
                content: ' |';
                opacity: 20% ;
            }
        `}
`;

export const WrapperContainer = styled.div`
    display: flex;
    width: ${({ width }) => width};
    max-width: ${({ maxWidth }) => maxWidth};
    ${media.smalDevice`
    width: auto;
        max-width:unset;
        `}
    ${media.mobileDevice`
         width: auto;
         max-width:unset;
    `}
`;

export const LotSerial = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #140F4B;
    letter-spacing: -0.1px;
    color: #140F4B;
    opacity: 1;
    ${media.mobileDevice`
        display: flex;
        font-family: 'AvenirNextWorld Demi';
        font-size: 13px;
        letter-spacing: -0.1px;
        color: #140F4B;
        opacity: 1;
  
    `}
`;

export const LotSerialValue = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    letter-spacing: 0px;
    color: #140F4B;
    opacity: 1;
    ${media.mobileDevice`
        font-family: 'AvenirNextWorld Regular';
        font-size: 13px;
        letter-spacing: 0px;
        color: #140F4B;
        opacity: 1;
    `}
    
`;

